import { useEffect, useRef, useState } from "react";
import { api } from "../../api/client";
import { Dropdown } from "../../components/shared";
import css from "./reportNudge.module.css";

/**
 * Чип «N отч.» / «Нет» в шапке карточки игры дашборда ОО (13.10, владелец: «это поле „1 отч.“ сделать
 * кликабельным — в выпадающем дропдауне пункт „отправить уведомление не сдавшим“, по нажатию на который не
 * сдавшим в ТГ-бот отправлялось бы сообщение „заполни отчёт“»). Кого звать, считает сервер
 * (POST /api/game-reports/:bookingId/nudge): назначенные без своего отчёта; итог — строкой под чипом.
 */
interface NudgeResp { ok: boolean; sent: string[]; failed: { name: string; reason: string }[]; skipped: { name: string; reason: string }[] }

const summary = (r: NudgeResp): string => [
  r.sent.length ? `✉ Отправлено: ${r.sent.join(", ")}` : "",
  r.failed.length ? `НЕ доставлено: ${r.failed.map((f) => `${f.name} (${f.reason})`).join(", ")}` : "",
  r.skipped.length ? `Пропущено: ${r.skipped.map((s) => `${s.name} — ${s.reason}`).join(", ")}` : "",
].filter(Boolean).join(" · ") || "Некому напоминать";

export function ReportNudgeChip({ bookingId, label, className, missing }: { bookingId: number; label: string; className: string; missing: string[] }) {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");
  const timer = useRef<number | undefined>(undefined);
  useEffect(() => () => window.clearTimeout(timer.current), []);

  const send = async () => {
    setBusy(true);
    try {
      setMsg(summary(await api<NudgeResp>(`/api/game-reports/${bookingId}/nudge`, { method: "POST", body: {} })));
    } catch (e) {
      setMsg(e instanceof Error ? e.message : "Не удалось отправить");
    }
    setBusy(false);
    window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setMsg(""), 8000);
  };

  return (
    <span className={css.wrap}>
      <button type="button" className={`${className} ${css.btn}`} aria-haspopup="menu" title={`Не сдали: ${missing.join(", ")}`}
        onClick={(e) => { e.stopPropagation(); setAnchor(e.currentTarget); }}>{busy ? "…" : label}</button>
      <Dropdown open={!!anchor} anchor={anchor} multi={false} filter={false} title={`Не сдали: ${missing.join(", ")}`}
        items={[{ id: "nudge", label: "Отправить уведомление не сдавшим", disabled: busy || !missing.length }]}
        onClose={() => setAnchor(null)} onCommit={(ids) => { if (ids[0] === "nudge") void send(); }} />
      {msg ? <span className={css.toast} role="status">{msg}</span> : null}
    </span>
  );
}
